if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });

/*$(".fabrics_picker_input").click(function() {
var max_checked = $(".fabrics_picker_input").data("tagtest");
var available = $(".fabrics_picker_input").data("available");
var bol = $("input:checkbox:checked").length >= max_checked +1;
if (bol || available=="n") {
	$("input:checkbox").not(":checked").attr("disabled",true);
} else {
    $("input:checkbox").not(":checked").attr("disabled",false);
}
});
*/

$(".fabrics_picker_input").click(function() {
var max_checked = $(".fabrics_picker_input").data("tagtest");
var bol = $("input:checkbox:checked").length >= max_checked +1;
$("input:checkbox").not(":checked").attr("disabled",bol);
});
}



function next() {
  	collection = arguments[0];
    id = parseInt($('.picker_li_'+collection+':visible').data('id').split('-')[1]) || 0;
    nextId = id+1;    
    nextnextId = id+2;    
    

    images = document.querySelectorAll("#pickerid"+collection+"-"+nextId+" img");
    for(var i = 0; i < images.length; i++)
    {
      images[i].src = images[i].getAttribute('data-src');
    }

    $('[data-id="'+collection+'-'+id+'"]').hide();
    $('[data-id="'+collection+'-'+nextId+'"]').show();
    
    if($('.previous').is(":hidden")){
        $('.previous').show();
      $('.arrow--left').show();
    };
  
  	var images_after = document.querySelectorAll("#pickerid"+collection+"-"+nextnextId+" img");
    if(images_after.length == 0){
        $('.next').hide();
      $('.arrow--right').hide();
    }
};

//$('body').on('click', '.previous', function() { 
function previous() {
  	collection = arguments[0];
	id = parseInt($('.picker_li_'+collection+':visible').data('id').split('-')[1]);
    prevId = id-1 || 0;
  
    $('[data-id="'+collection+'-'+id+'"]').hide();
    $('[data-id="'+collection+'-'+prevId+'"]').show();
    
    if(id == 1){
        $('.previous').hide();
        $('.arrow--left').hide();
    }
    if($('.next').is(":hidden")){
        $('.next').show();
        $('.arrow--right').show();
    };
};

function show() {
  collection = arguments[0]
  document.getElementById('pickerid'+collection+'-0');  
  

  var images = document.querySelectorAll("#pickerid"+collection+"-0 img");
  for(var i = 0; i < images.length; i++)
  {
    images[i].src = images[i].getAttribute('data-src');
  }
  var id = parseInt($('.picker_li_'+collection+':visible').data('id').split('-')[1]);

  if(id != 0){
    $('[data-id="'+collection+'-'+id+'"]').hide();
    $('[data-id="'+collection+'-0"]').show();
  }
    
  var images_after = document.querySelectorAll("#pickerid"+collection+"-1 img");
  if(images_after.length == 0){
    $('.next').hide();
    $('.arrow--right').hide();
  }
  else {
    $('.next').show();
    $('.arrow--right').show();
  };
  $('.previous').hide();
  $('.arrow--left').hide();
};

// limit word number in input fields
document.querySelectorAll('input[data-max-words]').forEach(input => {
  var maxWords = parseInt(input.getAttribute('data-max-words') || 0)
  input.addEventListener('keydown', e => {
    var target = e.currentTarget
    var words = target.value.split(/\s+/).length
    if( words > maxWords && e.keyCode && e.keyCode != 8){

	    e.preventDefault(); // Cancel event
  	}
  })});

$(document).ready(function(e) {
  $('.product-form__submit').click(function(e){
    if (document.getElementById("error_form_popup")) {
      var ddValue = $("input:checkbox:checked").length;
      if(ddValue == 0){
          $('#error_form_popup').show()
          e.preventDefault();
      }    
      else {
        $('#error_form_popup').hide()
    }};
  });
});

